import {Observable}                  from 'rxjs';
import {filter, map, withLatestFrom} from 'rxjs/operators';

import MediaEventType            from '../../../../Solutions/Shared/Constants/MediaEventType';
import IMediaEventsStreamPayload from '../../../../Solutions/Shared/Interfaces/IMediaEventsStreamPayload';
import Volume                    from '../Volume';

const createVolumeChangeStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>,
    volumeStoreUpdate$: Observable<Volume>
): Observable<number> =>
    mediaEvents$
        .pipe(
            withLatestFrom(volumeStoreUpdate$),
            filter(([{type, state}, latestVolumeStoreValue]) => (
                type === MediaEventType.VOLUME_CHANGE &&
                state.volume !== latestVolumeStoreValue.level
            )),
            map(([{state}]) => state.volume)
        );

export default createVolumeChangeStream;